module.exports = __webpack_public_path__ + "static/media/ErrorCircle.dcc8671b.svg";